module.exports = __webpack_public_path__ + "static/media/WashYourHands.c738e810.png";